export const GRACE_PERIOD_DIALOG_ID = 'grace-period-notification-dialog';
